import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import BaseData from "./BaseData";

var AFSReportCardCustomIncome =
/*#__PURE__*/
function (_BaseData) {
  _inherits(AFSReportCardCustomIncome, _BaseData);

  function AFSReportCardCustomIncome() {
    _classCallCheck(this, AFSReportCardCustomIncome);

    return _possibleConstructorReturn(this, _getPrototypeOf(AFSReportCardCustomIncome).call(this, "AFSReportCardCustomIncome"));
  }

  _createClass(AFSReportCardCustomIncome, [{
    key: "GetByReportCardId",
    value: function () {
      var _GetByReportCardId = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(reportCardId) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.get("/api/".concat(this._controller, "/GetByReportCardId/").concat(reportCardId)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function GetByReportCardId(_x) {
        return _GetByReportCardId.apply(this, arguments);
      }

      return GetByReportCardId;
    }()
  }]);

  return AFSReportCardCustomIncome;
}(BaseData);

export default new AFSReportCardCustomIncome();